import type {
	CORE_PROJECT,
	SOFTWARE_PROJECT,
	PRODUCT_DISCOVERY_PROJECT,
	ProjectType,
	CUSTOMER_SERVICE_PROJECT,
} from '@atlassian/jira-common-constants/src/project-types';

// In code and state the ProjectType is 'service_desk' but in analytics it should be 'serviceDesk'.
// Clarified in comments in https://hello.atlassian.net/wiki/spaces/JPLAT/pages/190064383/Event+Spec+-+Donut+World?focusedCommentId=190292046#comment-190292046
export type AnalyticsProjectType =
	| typeof SOFTWARE_PROJECT
	| typeof PRODUCT_DISCOVERY_PROJECT
	| typeof CORE_PROJECT
	| typeof CUSTOMER_SERVICE_PROJECT
	| 'serviceDesk';

export const convertProjectType = (projectType: ProjectType): AnalyticsProjectType => {
	if (projectType === 'service_desk') {
		return 'serviceDesk';
	}
	return projectType;
};

export const safeProjectType = (projectType: ProjectType) => convertProjectType(projectType);
